import { useEffect, useRef, useState } from "react";

export function useTextClamp() {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isClampable, setIsClampable] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (!isExpanded && textRef.current) {
      const checkClamp = () => {
        if (textRef.current) {
          setIsClampable(
            textRef.current.scrollHeight > textRef.current.clientHeight
          );
        }
      };

      checkClamp();

      const resizeObserver = new ResizeObserver(checkClamp);
      resizeObserver.observe(textRef.current);

      return () => resizeObserver.disconnect();
    }
  }, [isExpanded]);

  return { textRef, isClampable, isExpanded, setIsExpanded };
}
